import { render } from "./BlockContents.vue?vue&type=template&id=e68f294a&ts=true"
import script from "./BlockContents.vue?vue&type=script&lang=ts"
export * from "./BlockContents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__